import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly restrictions: { readonly __typename?: 'AccountsRestriction', readonly projectCreationRestricted: boolean }, readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly isClientAccess: boolean, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly lastError?: string | null, readonly provider: Types.OauthProvider }> }> } | null };

export type GetCurrentUserCompanyQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCurrentUserCompanyQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly type?: Types.AccountsUserType | null, readonly isNew: boolean, readonly isSubscriptionLimitExceeded: boolean, readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly isValid: boolean, readonly lastError?: string | null, readonly provider: Types.OauthProvider, readonly accounts: ReadonlyArray<{ readonly __typename?: 'YalperAccount', readonly id: string, readonly name: string, readonly currency: string }> }> } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    restrictions {
      projectCreationRestricted
    }
    companies {
      id
      isClientAccess
      name
      tokens {
        lastError
        provider
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetCurrentUserCompanyDocument = gql`
    query GetCurrentUserCompany($companyId: ID) {
  currentUser {
    type
    isNew
    isSubscriptionLimitExceeded
    roles
    company(id: $companyId) {
      id
      uuid
      name
      tokens {
        id
        isValid
        lastError
        provider
        accounts {
          id
          name
          currency
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserCompanyQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrentUserCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>(GetCurrentUserCompanyDocument, options);
      }
export function useGetCurrentUserCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>(GetCurrentUserCompanyDocument, options);
        }
export function useGetCurrentUserCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>(GetCurrentUserCompanyDocument, options);
        }
export type GetCurrentUserCompanyQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyQuery>;
export type GetCurrentUserCompanyLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyLazyQuery>;
export type GetCurrentUserCompanySuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserCompanySuspenseQuery>;
export type GetCurrentUserCompanyQueryResult = Apollo.QueryResult<GetCurrentUserCompanyQueryPage, GetCurrentUserCompanyQueryVariables>;